// import React,{useState} from 'react';
// import Linkpages from "./Linkpages";
// import '../css/vagadent.css';
// import '../css/media.css';
// import {useTranslation} from "react-i18next";
// import Slider from "react-slick";
//
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
//
//
// function Home(props) {
//     const {t, i18n} = useTranslation("common");
//
//     const [menuOpen, setMenuOpen] = useState(false);
//     const settings = {
//         dots: true,
//         autoplay: true,
//         speed: 1200,
//         autoplaySpeed: 5000,
//         infinite: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         fade: true,
//         customPaging: i => (
//             <div className="custom-dot">
//                 {i + 1}
//             </div>
//         )
//       };
//
//
//     return (
//
//         <div className="home-wrapper">
//             <div className="header-container">
//                 <div className="logo-group">
//                     <div className="logo"></div>
//                         <div className="brand-text">
//                             <div className="vagadent">{t('welcome.title')}</div>
//                             <div className="dental">{t('welcome.title1')}</div>
//                         </div>
//                 </div>
//                 <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
//                 <Linkpages/>
//                 </div>
//
//                    <div className="leng">
//                         <button onClick={()=>i18n.changeLanguage('hay')}>ՀԱՅ</button>
//                         <button onClick={()=>i18n.changeLanguage('ru')}>РУ</button>
//                         <button onClick={()=>i18n.changeLanguage('en')}>ENG</button>
//                    </div>
//
//                 <div className={`menu-dots ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                 </div>
//             </div>
//
//
//
//         <div className="Box">
//
//              <div className="Box1">
//                  <Slider {...settings} className={"Slider"}>
//                        <div className={"Slide1"}>{t('slider.modern_equip')}</div>
//                        <div className={"Slide2"}>{t('slider.painless')}</div>
//                        <div className={"Slide3"}>{t('slider.perfect_smile')}</div>
//                 </Slider>
//              </div>
//
//              <div className="bjishk">
//                  <div className="bjishk-anun">{t('doctor.name')}</div>
//                  <div className="bjishk-anun1">{t('doctor.position')}</div>
//              </div>
//          </div>
//
//
//         </div>
//     );
// }

// export default Home;


import React, { useState } from 'react';
import Linkpages from "./Linkpages";
import '../css/vagadent.css';
import '../css/media.css';
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Home(props) {
    const { t, i18n } = useTranslation("common");
    const [menuOpen, setMenuOpen] = useState(false);

    const settings = {
        dots: true,
        autoplay: true,
        speed: 1200,
        autoplaySpeed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        customPaging: i => (
            <div className="custom-dot">
                {i + 1}
            </div>
        )
    };

    return (
        <div className="home-wrapper">
            <div className="header-container">
                <div className="logo-group">
                    <div className="logo"></div>
                    <div className="brand-text">
                        <div className="vagadent">{t('welcome.title')}</div>
                        <div className="dental">{t('welcome.title1')}</div>
                    </div>
                </div>

                <div className={`nav-menu ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)}>
                    <Linkpages />
                </div>

                {/* ⚡ Ավելացվել է header-right div-ը լեզուների և գծիկների համար */}
                <div className="header-right">
                    <div className="leng">
                        <button onClick={() => i18n.changeLanguage('hay')}>ՀԱՅ</button>
                        <button onClick={() => i18n.changeLanguage('ru')}>РУ</button>
                        <button onClick={() => i18n.changeLanguage('en')}>ENG</button>
                    </div>

                    <div className={`menu-dots ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>

            <div className="Box">
                <div className="Box1">
                    <Slider {...settings} className={"Slider"}>
                        <div className={"Slide1"}>{t('slider.modern_equip')}</div>
                        <div className={"Slide2"}>{t('slider.painless')}</div>
                        <div className={"Slide3"}>{t('slider.perfect_smile')}</div>
                    </Slider>
                </div>

                <div className="bjishk">
                    <div className="bjishk-anun">{t('doctor.name')}</div>
                    <div className="bjishk-anun1">{t('doctor.position')}</div>
                </div>
            </div>
        </div>
    );
}



export default Home;